import React, { Component } from "react";
import { Map, Marker, GoogleApiWrapper } from "google-maps-react";

class MapContainer extends Component {
    constructor(props) {
        super(props);
        this.onMarkerClick = this.onMarkerClick.bind(this);
        this.state = {
            showingInfoWindow: false,
            activeMarker: {},
            selectedPlace: {}
        };
    }
    onMarkerClick(props, marker, e) {
        this.setState({
            selectedPlace: props,
            activeMarker: marker,
            showingInfoWindow: true
        });
    }
    render() {
        if (!this.props.google) {
            return <div>Loading...</div>;
        }

        return (
            <Map style={{}} google={this.props.google} zoom={16} initialCenter = {{ lat: 55.7504291, lng: 37.6265174 }}>
                <Marker
                    title = { 'Гастроцентр Зарядье' }
                    position = {{ lat: 55.7504256, lng: 37.628678 }}
                    name = { 'Гастроцентр Зарядье' }
                />
            </Map>
        );
    }
}
export default GoogleApiWrapper({
    apiKey: "AIzaSyA1vCj6tZmDGrrZMV6HN6iylhTyWaBPotM",
    v: "3.30"
})(MapContainer);


// WEBPACK FOOTER //
// ./src/js/components/MapContainer.js